import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io';

const Categorys = ({ selectedCategory, onSelect }) => {
  const { categorys } = useSelector(state => state.home);
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    const el = scrollRef.current;
    if (el) el.scrollBy({ left: dir === 'left' ? -320 : 320, behavior: 'smooth' });
  };

  if (!categorys?.length) return null;

  return (
    <div className="w-full flex items-center gap-2">

      {/* Left arrow */}
      <button
        onClick={() => scroll('left')}
        aria-label="Scroll left"
        className="flex-shrink-0 w-10 h-10 bg-white border border-gray-200 shadow-sm rounded-full flex items-center justify-center text-gray-500 hover:border-[#E21C1B] hover:text-[#E21C1B] transition-colors duration-150 z-10"
      >
        <IoIosArrowBack size={17} />
      </button>

      {/* Scrollable pill row */}
      <div
        ref={scrollRef}
        className="flex gap-3 overflow-x-auto scroll-smooth scrollbar-hide flex-1 py-1.5"
      >
        {/* "All" pill */}
        <button
          onClick={() => onSelect(null)}
          className={`flex-shrink-0 px-7 py-[11px] rounded-full text-[14px] font-semibold whitespace-nowrap transition-colors duration-150 ${
            selectedCategory === null
              ? 'bg-[#E21C1B] border border-[#E21C1B] text-white'
              : 'bg-white border border-gray-200 text-gray-700 hover:border-[#E21C1B] hover:text-[#E21C1B] hover:bg-red-50'
          }`}
        >
          All
        </button>

        {categorys.map((c, i) => (
          <button
            key={i}
            onClick={() => onSelect(c.name)}
            className={`flex-shrink-0 px-7 py-[11px] rounded-full text-[14px] font-medium whitespace-nowrap transition-colors duration-150 ${
              selectedCategory === c.name
                ? 'bg-[#E21C1B] border border-[#E21C1B] text-white'
                : 'bg-white border border-gray-200 text-gray-700 hover:border-[#E21C1B] hover:text-[#E21C1B] hover:bg-red-50'
            }`}
          >
            {c.name}
          </button>
        ))}
      </div>

      {/* Right arrow */}
      <button
        onClick={() => scroll('right')}
        aria-label="Scroll right"
        className="flex-shrink-0 w-10 h-10 bg-white border border-gray-200 shadow-sm rounded-full flex items-center justify-center text-gray-500 hover:border-[#E21C1B] hover:text-[#E21C1B] transition-colors duration-150 z-10"
      >
        <IoIosArrowForward size={17} />
      </button>

    </div>
  );
};

export default Categorys;
